import { render, staticRenderFns } from "./OptionsButton.vue?vue&type=template&id=67af46e0&scoped=true&"
import script from "./OptionsButton.vue?vue&type=script&lang=js&"
export * from "./OptionsButton.vue?vue&type=script&lang=js&"
import style0 from "./OptionsButton.vue?vue&type=style&index=0&id=67af46e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af46e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {VBtn,VDivider,VList,VListItem,VMenu})
